import React, { useState } from 'react';
import { Container, Tab, Tabs, Card, Row, Col } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';
import { useAuth } from 'components/authentication/signup-login/AuthContext';
import { Navigate } from 'react-router-dom';
import UsersTab from './UsersTab';
import ScreeningTab from './ScreeningTab';
import DemoTab from "./DemoTab";

const AdminConfig = () => {
  const { user, isAuthenticated } = useAuth();
  const [activeTab, setActiveTab] = useState('users');

  // Use the user from AuthContext which contains the is_admin property from login
  const displayUser = user;

  // Redirect if not authenticated or not admin
  if (!isAuthenticated || !displayUser?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container fluid className="py-4">
      {/* Profile Card */}
      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Body>
              <div className="d-flex align-items-center gap-3">
                {/* Avatar */}
                <div
                  className="d-flex align-items-center justify-content-center bg-primary text-white"
                  style={{
                    width: '60px',
                    height: '60px',
                    fontSize: '24px',
                    borderRadius: '8px',
                    overflow: 'hidden'
                  }}
                >
                  {displayUser?.avatar ? (
                    <img
                      src={displayUser.avatar}
                      alt="User Avatar"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '0'
                      }}
                    />
                  ) : (
                    <FaUser />
                  )}
                </div>

                {/* User Info */}
                <div>
                  <h4 className="mb-0">{displayUser?.name || 'Admin'}</h4>
                  <small className="text-muted">{displayUser?.email}</small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Admin Header */}
     
      {/* Tabs */}
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-4"
      >
        <Tab eventKey="users" title="Users">
          <UsersTab />
        </Tab>
        <Tab eventKey="screening" title="Screening Info">
          <ScreeningTab />
        </Tab>
                <Tab eventKey="demo" title="Demos">
          <DemoTab />
        </Tab>

        {/* Add more tabs here in the future */}
      </Tabs>
    </Container>
  );
};

export default AdminConfig;